<template>
  <div class="popular-movie">
    <div class="popular-movie__header">
      <div class="popular-movie__title-wrapper">
        <div class="popular-movie__title">Popular Movies</div>
        <a class="popular-movie__more" :href="moreUrl">
          <div class="popular-movie__more-text">More</div>
          <div class="popular-movie__more-icon">
            <img class="popular-movie__more-arrow" src="@/assets/icon/arrow_right_alt.svg" />
          </div>
        </a>
      </div>
      <div class="popular-movie__controls">
        <div class="popular-movie__control popular-movie__control--prev"
          :class="{ 'popular-movie__control--disabled': !hasPrev }" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="popular-movie__control-arrow" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.56641 6.00382L5.79139 1.35876C5.9351 1.20076 6.00456 1.0138 5.99977 0.797876C5.99498 0.581949 5.92073 0.394988 5.77702 0.236993C5.63332 0.0789977 5.46326 0 5.26686 0C5.07046 0 4.90041 0.0789977 4.7567 0.236993L0.344896 5.10325C0.229931 5.22965 0.143707 5.37184 0.0862241 5.52984C0.0287414 5.68783 0 5.84583 0 6.00382C0 6.16182 0.0287414 6.31981 0.0862241 6.47781C0.143707 6.6358 0.229931 6.778 0.344896 6.9044L4.77107 11.7707C4.91478 11.9286 5.08244 12.005 5.27405 11.9997C5.46566 11.9945 5.63332 11.9128 5.77702 11.7549C5.92073 11.5969 5.99258 11.4099 5.99258 11.194C5.99258 10.978 5.92073 10.7911 5.77702 10.6331L1.56641 6.00382Z"
              fill="white" />
          </svg>
        </div>
        <div class="popular-movie__control popular-movie__control--next"
          :class="{ 'popular-movie__control--disabled': !hasNext }" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="popular-movie__control-arrow"
            viewBox="0 0 6 12" fill="none">
            <path
              d="M4.43359 6.00382L0.208607 1.35876C0.0649 1.20076 -0.00455845 1.0138 0.000231786 0.797876C0.00502202 0.581949 0.0792707 0.394988 0.222978 0.236993C0.366685 0.0789977 0.536738 0 0.733138 0C0.929537 0 1.09959 0.0789977 1.2433 0.236993L5.6551 5.10325C5.77007 5.22965 5.85629 5.37184 5.91378 5.52984C5.97126 5.68783 6 5.84583 6 6.00382C6 6.16182 5.97126 6.31981 5.91378 6.47781C5.85629 6.6358 5.77007 6.778 5.6551 6.9044L1.22893 11.7707C1.08522 11.9286 0.917562 12.005 0.725952 11.9997C0.534343 11.9945 0.366685 11.9128 0.222978 11.7549C0.0792707 11.5969 0.00741714 11.4099 0.00741714 11.194C0.00741714 10.978 0.0792707 10.7911 0.222978 10.6331L4.43359 6.00382Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
    <div class="popular-movie__slider">
      <div class="popular-movie__slider-container" ref="sliderContainer">
        <template v-if="deviceType !== 'mobile'">
          <div v-for="(movie, index) in movies" :key="index" class="popular-movie__card"
            @click="navigateToDetail(movie)">
            <div class="popular-movie__card-index">{{ index + 1 }}</div>
            <div class="popular-movie__card-poster">
              <img class="popular-movie__card-img" :src="movie.poster" alt="" />
            </div>
            <div class="popular-movie__card-info">
              <div class="popular-movie__card-category">{{ movie.category }}</div>
              <div class="popular-movie__card-title">{{ movie.title }}</div>
              <div class="popular-movie__card-date">{{ movie.date }}</div>
              <div class="popular-movie__card-rating">
                <img class="popular-movie__card-star" src="@/assets/icon/star.svg" />
                <div class="popular-movie__card-score">{{ Number(movie.score).toFixed(1) }}</div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <!-- 移动端布局 -->
          <div class="popular-movie__mobile-container">
            <div class="popular-movie__grid">
              <div v-for="(movie, index) in movies" :key="`movie-${index}`"
                class="popular-movie__card" @click="navigateToDetail(movie)"
                :class="{'popular-movie__card--odd': (index + 1) % 2 !== 0, 'popular-movie__card--even': (index + 1) % 2 === 0}">
                <div class="popular-movie__card-index">{{ index + 1 }}</div>
                <div class="popular-movie__card-poster">
                  <img class="popular-movie__card-img" :src="movie.poster" alt="" />
                </div>
                <div class="popular-movie__card-info">
                  <div class="popular-movie__card-category">{{ movie.category }}</div>
                  <div class="popular-movie__card-title">{{ movie.title }}</div>
                  <div class="popular-movie__card-date">{{ movie.date }}</div>
                  <div class="popular-movie__card-rating">
                    <img class="popular-movie__card-star" src="@/assets/icon/star.svg" />
                    <div class="popular-movie__card-score">{{ Number(movie.score).toFixed(1) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PopularMovie',
  props: {
    movies: {
      type: Array,
      default: () => []
    },
    moreUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentIndex: 0,
      visibleItems: 5,
      totalItems: 0
    };
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    hasPrev () {
      return this.currentIndex > 0;
    },
    hasNext () {
      return this.currentIndex + this.visibleItems < this.totalItems;
    }
  },
  watch: {
    movies: {
      immediate: true,
      handler (newVal) {
        this.totalItems = newVal.length;
      }
    }
  },
  methods: {
    prevSlide () {
      if (this.hasPrev) {
        this.currentIndex--;
        this.scrollSlider();
      }
    },
    nextSlide () {
      if (this.hasNext) {
        const container = this.$refs.sliderContainer;
        if (container) {
          const cardWidth = container.querySelector('.popular-movie__card').offsetWidth;
          const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));
          const sliderWidth = this.$el.querySelector('.popular-movie__slider').offsetWidth;

          // 如果是最后几个元素，确保显示到最后一个
          if (this.currentIndex + this.visibleItems + 1 >= this.totalItems) {
            // 计算可以显示的最大索引，确保最后一个卡片完全可见
            const maxIndex = this.totalItems - Math.floor(sliderWidth / (cardWidth + gapWidth));
            this.currentIndex = Math.max(0, maxIndex);
          } else {
            this.currentIndex++;
          }
          this.scrollSlider();
        }
      }
    },
    scrollSlider () {
      const container = this.$refs.sliderContainer;
      if (container) {
        const cardWidth = container.querySelector('.popular-movie__card').offsetWidth;
        const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));

        // 获取左侧padding值
        const sliderElement = this.$el.querySelector('.popular-movie__slider');
        const leftPadding = parseInt(window.getComputedStyle(sliderElement).getPropertyValue('padding-left'));

        let translateX = 0;
        if (this.currentIndex === 0) {
          // 第一个位置，不需要偏移
          translateX = 0;
        } else if (this.currentIndex === 1) {
          // 第一次滚动，需要考虑左侧padding
          translateX = leftPadding + cardWidth + gapWidth;
        } else {
          // 后续滚动，考虑第一张卡片和左侧padding，以及后续的卡片和间距 间距是两侧的 所以要加两遍
          translateX = leftPadding + cardWidth + gapWidth + (this.currentIndex - 1) * (cardWidth + gapWidth);
        }

        container.style.transform = `translateX(-${translateX}px)`;
      }
    },
    navigateToDetail (movie) {
      // 格式化电影名称为URL友好的格式
      const formattedName = movie.title ? movie.title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '') : 'movie';

      // 准备保存到本地存储的数据
      const movieData = {
        id: movie.id,
        title: movie.title,
        poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${movie.poster_path}`,
        genres: movie.genre_ids ? movie.genre_ids.map(id => {
          const genre = this.movieGenres.find(g => g.id === id);
          return genre ? genre.name : '';
        }).filter(Boolean) : [],
        score: movie.vote_average,
        date: movie.release_date,
        description: movie.overview,
        type: 'movie' // 标记为电影类型
      };

      // 保存数据到本地存储
      localStorage.setItem('selectedMovie', JSON.stringify(movieData));

      // 跳转到详情页
      this.$router.push(`/movies/${movie.id}-${formattedName}/`);
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.popular-movie {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__header {
		padding: 0 rem(80);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
		width: 100%;
	}

	&__title-wrapper {
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__more {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__more-text {
		color: #fe324b;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__more-icon {
		width: rem(16);
		height: rem(12);
		position: relative;
	}

	&__more-arrow {
		width: 100%;
		overflow: visible;
	}

	&__controls {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-end;
		position: relative;
	}

	&__control {
		width: rem(28);
		height: rem(28);
		position: relative;
		cursor: pointer;

		&::before {
			content: '';
			background: #ffffff;
			border-radius: 100px;
			opacity: 0.1;
			width: rem(28);
			height: rem(28);
			position: absolute;
			left: 0;
			top: 0;
		}

		&--disabled {
			opacity: 0.5;
			cursor: default;
		}
	}

	&__control-arrow {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: rem(6);
		height: rem(12);
	}

	&__slider {
		padding: 0 0 0 rem(80);
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	&__slider-container {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		transition: transform 0.3s ease;
		// padding-right: rem(80);
		padding-top: rem(6);
	}

	&__card {
		padding: 0 rem(32) 0 0;
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		width: rem(306);
		position: relative;
		flex-shrink: 0;
		cursor: pointer;
		transition: transform 0.3s ease;

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__card-index {
		color: #ffffff;
		text-align: left;
		font-size: rem(44);
		line-height: rem(44);
		font-weight: 400;
		position: relative;
		min-width: rem(24);
		width: fit-content;
		font-family: Impact;
	}

	&__card-poster {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: rem(100);
		height: rem(150);
		position: relative;
		overflow: hidden;
		margin-right: rem(2);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__card-info {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		flex: 1;
		height: rem(130);
		position: relative;
	}

	&__card-category {
		border-radius: rem(8);
		border: 1px solid rgba(255, 255, 255, 0.2);
		padding: rem(4) rem(8);
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(14);
		font-weight: 400;
		opacity: 0.6;
		margin-bottom: rem(16);
		display: inline-block;
	}

	&__card-title {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 500;
		margin-bottom: rem(8);
		width: 100%;
	}

	&__card-date {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		text-transform: uppercase;
		opacity: 0.6;
		width: 100%;
	}

	&__card-rating {
		border-radius: rem(16) 0 rem(16) 0;
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		margin-top: auto;
	}

	&__card-star {
		width: rem(12);
		height: rem(12);
	}

	&__card-score {
		color: #ffaf00;
		text-align: left;
		font-family: 'Inter-Bold', sans-serif;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		text-transform: uppercase;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.popular-movie {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.popular-movie {
		gap: rem(24);

		&__header {
			padding: 0 rem(16);
			flex-direction: column;
			align-items: flex-start;
		}

		&__title-wrapper {
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);
			width: 100%;
		}

		&__controls {
			display: none;
		}

		&__slider {
			padding: 0 0 0 rem(16);
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__mobile-container {
			display: flex;
			flex-direction: column;
			width: 100%;
			// padding-right: rem(16);
		}

		&__grid {
			display: grid;
			grid-template-rows: repeat(2, auto);
			grid-auto-flow: column;
			gap: rem(20);
			width: 100%;
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__card {
			padding: 0 rem(32) 0 0;
			display: flex;
			flex-direction: row;
			gap: rem(12);
			align-items: center;
			justify-content: flex-start;
			width: rem(306);
			position: relative;
			flex-shrink: 0;

			// 奇数索引的卡片在第一行
			&--odd {
				grid-row: 1;
			}

			// 偶数索引的卡片在第二行
			&--even {
				grid-row: 2;
			}
		}

		&__card-index {
			color: #ffffff;
			font-size: rem(44);
			line-height: rem(44);
			width: rem(44);
		}

		&__card-poster {
			width: rem(100);
			height: rem(150);
		}

		&__card-info {
			height: rem(130);
		}

		&__card-category {
			margin-bottom: rem(16);
		}

		&__card-title {
			margin-bottom: rem(8);
			font-size: rem(16);
			line-height: rem(20);
		}
	}
}
</style> 